/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const pwa = {
  pwa: {
    addToHomeScreenDescription:
      'Agregue SAP Storefront a la pantalla de inicio de su dispositivo para una visita de regreso más rápida',
    noInstallationNeeded: 'No necesita instalación',
    fastAccessToApplication: 'Acceso rápido a la aplicación',
    addToHomeScreen: 'Agregar a la pantalla de inicio',
    addedToHomeScreen: 'SAP Storefront se ha añadido a la pantalla de inicio',
  },
};
